var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckups({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_3728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 23,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0144 0.344238H24.2792V20.9692H2.0144V0.344238Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_3728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1482 20.9692L3.86041 11.4556C3.70678 11.2991 3.55766 11.1299 3.4178 10.9536L4.19968 10.3228C4.31728 10.4713 4.44288 10.6137 4.57248 10.746L13.1482 19.53L21.7224 10.747C23.7989 8.62116 23.7989 5.1619 21.7227 3.03553L21.6361 2.94613C20.6348 1.92033 19.3015 1.35439 17.8836 1.35439C16.4657 1.35439 15.1323 1.92007 14.129 2.9479L13.148 3.95325L12.1679 2.94765C11.1648 1.92033 9.83151 1.35439 8.41361 1.35439C6.9957 1.35439 5.66237 1.92033 4.65905 2.9479L4.57298 3.03604C3.56867 4.06488 3.01522 5.43413 3.01522 6.89153H2.0144C2.0144 5.1672 2.66994 3.54616 3.86041 2.32666L3.94673 2.23852C5.13894 1.017 6.72574 0.344238 8.41361 0.344238C10.1015 0.344238 11.6883 1.017 12.8812 2.23903L13.1485 2.51303L13.4159 2.23903C14.6089 1.017 16.1957 0.344238 17.8836 0.344238H17.8838C19.5717 0.344238 21.1582 1.01725 22.3507 2.23903L22.4373 2.32843C24.8935 4.8437 24.8935 8.9391 22.4353 11.4559L13.1482 20.9692Z",
    fill: "#572580"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52234 12.1419L7.94531 6.86538L6.92598 9.241H0.348633V8.23085H6.2687L8.11395 3.9314L9.7788 9.50238L10.5947 7.95281H17.1618V8.96296H11.1962L9.52234 12.1419Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckups);
export default __webpack_public_path__ + "static/media/checkups.25f349413b88383b0f388e996cef486b.svg";
export { ForwardRef as ReactComponent };